import { render, staticRenderFns } from "./BowImage.vue?vue&type=template&id=6c975804&"
import script from "./BowImage.vue?vue&type=script&lang=js&"
export * from "./BowImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports